// // export const CareerLookFor = [
// //   {
// //     subHeading: [
// //       {
// //         icon: require("../../../public/images/careerimages/why-career01.webp").default,
// //         heading: "Zeal to Contribute",
// //         content:
// //           "Enthusiasm is the key to achieving great results in all that we do.",
// //       },
// //       {
// //         icon: require("../../../public/images/careerimages/why-career03.webp").default,
// //         heading: "Verity in Work",
// //         content:
// //           "Being true to work is what makes all the difference in the end results.",
// //       },
// //     ],
// //   },
// //   {
// //     subHeading: [
// //       {
// //         icon: require("../../../public/images/careerimages/why-career02.webp").default,
// //         heading: "Team Spirit",
// //         content:
// //           "You should be a team spirit who trusts in coordination & cooperation.",
// //       },
// //       {
// //         icon: require("../../../public/images/careerimages/why-career04.webp").default,
// //         heading: "Integrity & Honesty",
// //         content:
// //           "Honesty is still the best policy and integrity makes it steadfast.",
// //       },
// //     ],
// //   },
// // ];

// // export const CareersDataFirst = [
// //   {
// //     icon: require("../../../public/images/careerimages/GlobalLearningOpportunity.webp").default,
// //     heading: "Learning Opportunity",
// //     content:
// //       "Exposure to different, challenging projects provides our people an opportunity of learning from real projects. Our team comprises of experts in different technologies with varying levels of experiences which means there is always an opportunity to learn. ",
// //   },
// //   {
// //     icon: require("../../../public/images/careerimages/FlexibleWorkingHours.webp").default,
// //     heading: "Flexible Working Hours",
// //     content:
// //       "Flexi timings are a great boon for modern offices and we understand the need of flexible working hours for our employees. Some people wake up early and wind up their work early while others are night who become more active during the latter part of the day.",
// //   },
// //   {
// //     icon: require("../../../public/images/careerimages/Everydaylearning.webp").default,
// //     heading: "Everyday learning",
// //     content:
// //       "Every day brings along a unique set of opportunities and challenges. You learn every day and that gives the much needed thrust to your career as you are more informed, powered with the latest and most advanced knowledge about the technology at hand.",
// //   },
// //   {
// //     icon: require("../../../public/images/careerimages/StreamlineCareerGrowth.webp").default,
// //     heading: "Career Growth",
// //     content:
// //       "At Tycho, we strongly believe in providing equal opportunities of growth to all. As an equal opportunity provider, we strive to ensure your growth – from knowledge growth to financial growth and more. Let us work together, grow together and succeed together.",
// //   },
// //   {
// //     icon: require("../../../public/images/careerimages/Awards&AppreciationRewards.webp").default,
// //     heading: "Awards & Appreciation",
// //     content:
// //       "Who doesn’t like getting rewarded? If you too do care for recognitions and appreciations, then it is time to join Tycho where awards and appreciations come directly to the performing. All you need to do is focus on your work and awards. ",
// //   },
// //   {
// //     icon: require("../../../public/images/careerimages/WorkLifeBalance.webp").default,
// //     heading: "Work-Life Balance",
// //     content:
// //       "The biggest irony of working in the IT industry is that you have to put your personal life at stake to maintain your professional life and vice versa. But when you join Tycho, you can be sure that our office hours will not interfere with your personal life and schedule.",
// //   },
// // ];
// // 1. What we look for in candidates
// export const CareerLookFor = [
//   {
//     id: "group-1",
//     items: [
//       {
//         icon: "/images/careerimages/why-career01.webp",
//         heading: "Zeal to Contribute",
//         content: "Enthusiasm is the key to achieving great results in all that we do.",
//       },
//       {
//         icon: "/images/careerimages/why-career03.webp",
//         heading: "Verity in Work",
//         content: "Being true to work is what makes all the difference in the end results.",
//       },
//     ],
//   },
//   {
//     id: "group-2",
//     items: [
//       {
//         icon: "/images/careerimages/why-career02.webp",
//         heading: "Team Spirit",
//         content: "You should be a team player who trusts in coordination & cooperation.",
//       },
//       {
//         icon: "/images/careerimages/why-career04.webp",
//         heading: "Integrity & Honesty",
//         content: "Honesty is still the best policy and integrity makes it steadfast.",
//       },
//     ],
//   },
// ];

// // 2. Employee Benefits & Culture
// export const CareersBenefits = [
//   {
//     icon: "Images/careerimages/GlobalLearningOpportunity.webp",

//     heading: "Learning Opportunity",
//     content: "Exposure to different, challenging projects provides our people an opportunity of learning from real projects. Our team comprises of experts in different technologies.",
//   },
//   {
//     icon: "Images/careerimages/FlexibleWorkingHours.webp",
//     heading: "Flexible Working Hours",
//     content: "Flexi timings are a great boon for modern offices. We understand the need for flexible working hours, whether you are an early bird or a night owl.",
//   },
//   {
//     icon: "Images/careerimages/EverydayLearning.webp",
//     heading: "Everyday Learning",
//     content: "Every day brings unique opportunities and challenges. You learn every day, keeping you informed and powered with the latest advanced technology knowledge.",
//   },
//   {
//     icon: "Images/careerimages/CareerGrowth.webp",
//     heading: "Career Growth",
//     content: "At Tycho, we strongly believe in providing equal opportunities of growth to all—from knowledge expansion to financial growth and beyond.",
//   },
//   {
//     icon: "Images/careerimages/AwardsAppreciation.webp",
//     heading: "Awards & Appreciation",
//     content: "If you care for recognition, it is time to join Tycho where awards and appreciations come directly to those who perform and focus on excellence.",
//   },
//   {
//     icon: "Images/careerimages/WorkLifeBalance.webp",
//     heading: "Work-Life Balance",
//     content: "At Tycho, you can be sure that our office hours will not interfere with your personal life. We respect your schedule and your life outside work.",
//   },
// ];

// // 3. Current Openings

// export const OpenPositionCareer = [
//   {
//     category: "Development",
//     roles: [
//       { id: 1, heading: "React JS Developer", url: "/careers/react-developer" },
//       { id: 2, heading: "Flutter Developer", url: "/careers/flutter-developer" },
//       { id: 3, heading: "Node JS Developer", url: "/careers/node-developer" },
//     ]
//   },
//   {
//     category: "Mobile & Backend",
//     roles: [
//       { id: 4, heading: "Android Developer", url: "/careers/android-developer" },
//       { id: 5, heading: "iOS Developer", url: "/careers/iOS-developer" },
//       { id: 6, heading: "PHP Developer", url: "/careers/php-developer" },
//     ]
//   },
//   {
//     category: "Support & QA",
//     roles: [
//       { id: 7, heading: "OTT Developer", url: "/careers/ott-developer" },
//       { id: 8, heading: "Technical Support Lead", url: "/careers/tech-support-lead" },
//       { id: 9, heading: "QA Engineer", url: "/careers/qa-engineer" },
//     ]
//   }
// ];

// Mock data for Careers page components

export const CareersBenefits = [
  {
    icon: "Images/careerimages/GlobalLearningOpportunity.webp",
    heading: "Learning Opportunity",
    content: "Expand your skills through hands-on projects, collaborative learning, expert guidance, and continuous exposure to modern technologies and industry practices.",
  },
  {
    icon: "Images/careerimages/FlexibleWorkingHours.webp",
    heading: "Flexible Working Hours",
    content: "We believe in productivity with flexibility, allowing team members to manage their schedules while maintaining efficiency, creativity, and work quality.",
  },
  {
    icon: "Images/careerimages/EverydayLearning.webp",
    heading: "Everyday Learning",
    content: "Our culture encourages continuous technical growth, innovation, and knowledge sharing to help individuals evolve with modern industry trends.",
  },
  {
    icon: "Images/careerimages/StreamlineCareerGrowth.webp",
    heading: "Career Growth",
    content: "We provide clear growth opportunities, skill development pathways, and the right mentorship to help professionals achieve long-term career success.",
  },
  {
    icon: "Images/careerimages/Awards&AppreciationRewards.webp",
    heading: "Awards & Appreciation",
    content: "Great work deserves recognition. We celebrate achievements, reward contributions, and encourage a positive culture of appreciation and motivation.",
  },
  {
    icon: "Images/careerimages/WorkLifeBalance.webp",
    heading: "Work-Life Balance",
    content: "We support a healthy work environment that values personal well-being, sustainable productivity, and balance between professional and personal life.",
  },
];

export const CareerLookFor = [
  {
    items: [
      {
        icon: "/images/careerimages/why-career01.webp",
        heading: "Zeal to Contribute",
        content: "We value individuals who bring energy, dedication, and a proactive mindset to every project, helping teams achieve meaningful and impactful results.",
      },
      {
        icon: "/images/careerimages/why-career03.webp",
        heading: "Verity in Work",
        content: "We believe honesty, accountability, and commitment to quality are essential for delivering reliable work and building long-term professional trust.",
      },
      {
        icon: "/images/careerimages/why-career02.webp",
        heading: "Team Spirit",
        content: "Strong collaboration and shared ideas drive innovation. We encourage teamwork that combines diverse skills to achieve exceptional outcomes together.",
      },
      {
        icon: "/images/careerimages/why-career04.webp",
        heading: "Integrity & Honesty",
        content: "Integrity forms the foundation of our work culture, guiding every decision with transparency, responsibility, and professional ethics.",
      },
    ],
  },
];
